import { render } from "./Datepicker.vue?vue&type=template&id=efb1c5dc&ts=true"
import script from "./Datepicker.vue?vue&type=script&lang=ts"
export * from "./Datepicker.vue?vue&type=script&lang=ts"

import "./Datepicker.vue?vue&type=style&index=0&id=efb1c5dc&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__